import React, { useState } from 'react'
import departamentos from '../../data/deparments.json';
import './ChaptersComponent.css';

const VideoLoading = ({ imgPrev, vidPrev }) => {
  return (
    <>
      {vidPrev && vidPrev !== null ? (
        <div className="card bg-aqua text-white" style={{ borderRadius: '15px', backgroundColor: '#d7ecff' }}>
          <div className="card-body d-flex flex-column align-items-center">
            <video src={vidPrev} alt="Your Alt Text" className="img-fluid" controls loop="true"></video>
          </div>
        </div>
      ) : (
        <div className="card bg-aqua text-white" style={{ borderRadius: '15px', backgroundColor: '#d7ecff' }}>
          <div className="card-body d-flex flex-column align-items-center">
            <img src="Thumbnail.png" alt="generic" className="img-fluid" />
          </div>
        </div>
      )}

    </>
  )
}

const ChaptersComponent = ({ deparments, cointainsMap }) => {
  const [accordionOpen, setAccordionOpen] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState({ imgPrev: "Thumbnail.png", vidPrev: null });

  const toggleAccordion = (index) => {
    if (accordionOpen === index) {
      setAccordionOpen(null); // Cierra el accordion si se hace clic nuevamente en el mismo
    } else {
      setAccordionOpen(index); // Abre el accordion correspondiente al índice
    }
  };

  const handleMediaClick = (img, vid) => {
    setSelectedMedia({ imgPrev: img, vidPrev: vid });
  };


  return (
    <>
      {/* <!-- Contenido principal capitulos --> */}
      <div className='d-flex flex-column align-items-center'>
        <h1 className='text-center fw-bold text-warning mt-4'>Capítulos</h1>

        <div className='container'>
          <div className='row justify-content-center mt-3'>
            <div className='col-12 col-md-6 col-lg-5 col-xl-5 mb-5'>
              <p className='text-justify mb-0 text-center fs-5 text-dark-blue'>¡Acompáñenos en nuestro</p>
              <h3 className='text-justify mb-0 text-center fw-bold text-dark-blue'>recorrido por el país!</h3>

              <section className="py-3 scrolling mt-3 mb-5">
                <div className="container">
                  <div className="w-lg-100 mx-auto">
                    <div className="accordion accordion-flush" id="accordionExample">
                      {departamentos.departamentos.map((dep, index) => (
                        <div
                          key={index}
                          className="accordion-item bg-transparent mb-2"
                        >
                          <h2 className="accordion-header">
                            {dep.enabled ? (
                              <button
                                className={`accordion-button accordion-button-dark ${accordionOpen === index ? '' : 'collapsed'} ${accordionOpen === index ? 'bg-actived' : 'bg-normal'}`}
                                type="button"
                                onClick={() => toggleAccordion(index, dep.name)}
                                aria-expanded={accordionOpen === index ? 'true' : 'false'}
                                aria-controls={`coll${index}`}
                                data-bs-toggle="collapse"
                                data-bs-target={`#coll${index}`}
                              >
                                <h6 className='p-1 mx-5 fs-6 mt-1 mb-1 text-dark-blue fw-bold'>{dep.nombre}</h6>
                                <span className={`ms-2 text-dark-blue fw-bold ${accordionOpen === index ? 'rotate' : ''}`}></span>
                              </button>
                            ) : (
                              <button
                                className={`accordion-button accordion-button-dark-disabled ${accordionOpen === index ? '' : 'collapsed'} ${accordionOpen === index ? 'bg-actived' : 'bg-normal'}`}
                                type="button"
                                onClick={() => toggleAccordion(index, dep.name)}
                                aria-expanded={accordionOpen === index ? 'true' : 'false'}
                                aria-controls={`coll${index}`}
                                data-bs-toggle="collapse"
                                data-bs-target={`#coll${index}`}
                                disabled="true"
                              >
                                <h6 className={`p-1 mx-5 fs-6 mt-1 mb-1 fw-bold ${dep.enabled ? 'text-dark-blue' : 'text-gray-button'}`}>{dep.nombre}</h6>
                                <span className={`ms-2 text-dark-blue fw-bold ${accordionOpen === index ? 'rotate' : ''}`}></span>
                              </button>
                            )}
                          </h2>
                          <div
                            id={`coll${index}`}
                            className={`accordion-collapse collapse ${accordionOpen === index ? 'show' : ''}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body d-flex flex-column justify-content-center align-items-center col-12">
                              <div className="row">
                                <div className="col-12 col-md-5 col-lg-5 col-xl-5">
                                  {dep.data ? (
                                    dep.data.map((dataDep, index) => (
                                      <img
                                        key={index}
                                        src="Thumbnail.png"
                                        alt="Descripción de la imagen"
                                        className="img-fluid pointer"
                                        style={{ maxWidth: '130px' }}
                                        onClick={() => handleMediaClick("Thumbnail.png", dataDep.video)}
                                      />
                                    ))
                                  ) : (
                                    <img
                                      key={index}
                                      src="Thumbnail.png"
                                      alt="Descripción de la imagen"
                                      className="img-fluid pointer"
                                      style={{ maxWidth: '130px' }}
                                      onClick={() => handleMediaClick("Thumbnail.png", null)}
                                    />
                                  )}
                                </div>
                                <div className="col-12 col-md-7 col-lg-7 col-xl-7">
                                  <p className="text-sm-center text-md-start mb-md-2 font-13 mb-0">
                                    <strong className='text-dark-blue'>Capítulo 1:</strong> Experiencia con <br />
                                    Semaglutida oral en Colombia. <br />
                                    <strong className='text-dark'>Dr. Fredy Andrés Luna</strong> <br />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="col-12 col-md-6 col-lg-7 col-xl-7 mb-5">
              <VideoLoading imgPrev={selectedMedia.imgPrev} vidPrev={selectedMedia.vidPrev} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}


export default ChaptersComponent;
